module.exports = __webpack_public_path__ + "../front/img/468_4_skuffer+hylder.bb3cbc4c.svg";